import React from 'react'
import { BlockLink, Text, Button } from 'pcln-design-system'
import analytics from '../../utils/analytics'
import { InventoryWrapper } from './Common'
import { ANALYTICS_CATEGORY_HOME } from '../../constants/analytics'

export default function NoInventoryFallback({
  xSellMessaging,
  xSellTarget,
  xSellUrl
}: {
  xSellMessaging: string
  xSellTarget: 'Rental Cars' | 'Hotels' | 'Flights'
  xSellUrl: string
}) {
  return (
    <InventoryWrapper>
      <Text
        color="primary"
        fontSize={3}
        fontWeight="bold"
        mb="24px"
        lineHeight="24px"
      >
        {xSellMessaging}
      </Text>
      <BlockLink
        onClick={() => {
          analytics.fireEvent({
            action: 'Feature Box CTA',
            category: ANALYTICS_CATEGORY_HOME,
            label: 'Cross Sell Search Button'
          })
        }}
        href={xSellUrl}
        target="_new"
      >
        <Button data-autobot-element-id="XSELL_SEARCH_BUTTON" size="large">
          Search {xSellTarget}
        </Button>
      </BlockLink>
    </InventoryWrapper>
  )
}
